export function postMessage(message: string) {
  const data = {
    sso: message,
  };
  const target = window.parent ? window.parent.origin : "*";
  window.postMessage(JSON.stringify(data), target);
}
